var _path, _path2, _path3, _path4, _path5, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscoverys = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 112,
  height: 96,
  viewBox: "0 0 112 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.127 4.996.27 6.886 0 4.186 30.525 0h10.94v93.435H52V96H.945v-2.565h14.182V4.995Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M36 29.222 57.333 23v49.778L36 79V29.222Z",
  fill: "#265682"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.333 72.028V24.333l19.334 5.64v47.694l-19.334-5.64Z",
  stroke: "#265682",
  strokeWidth: 2
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M78.667 29.222 100 23v49.778L78.667 79V29.222Z",
  fill: "#265682"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M84.693 24.797C84.693 34.075 68.318 53 68.318 53S51.693 34.075 51.693 24.797C51.693 15.52 59.08 8 68.193 8s16.5 7.52 16.5 16.797Z",
  fill: "#D6BB96"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 67.956,
  cy: 23.919,
  rx: 6.981,
  ry: 7.107,
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 26,
  y1: 0,
  x2: 26,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEFF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEFF2",
  stopOpacity: 0
})))));
export default SvgDiscoverys;